import React from "react";
import { BaseIcon, BaseIconProps } from "./baseIcon";

export const WoofiStakeIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props} viewBox="0 0 18 19">
      <path
        d="M14.4333 15.5449L13.5283 13.3949C13.3283 12.8099 12.8233 12.5149 12.2183 12.5149C11.6133 12.5149 11.1083 12.9049 10.9083 13.3949L9.89825 15.5449L8.38825 10.7549H6.47325L8.69325 17.6949C8.79325 17.9899 8.99325 18.1849 9.29825 18.1849H10.4083C10.7083 18.1849 10.9133 17.9899 11.0133 17.7949L12.1233 15.0599L13.3333 17.7949C13.4333 17.9899 13.6333 18.1849 13.9383 18.1849H14.9483C15.2483 18.1849 15.4532 17.9899 15.5533 17.7949L16.5633 14.4699H14.7483L14.4333 15.5449Z"
        className="oui-fill-base-contrast-80"
      />
      <path
        d="M15.9433 10.76L15.0333 13.495H16.9483L17.7583 10.76H15.9433Z"
        className="oui-fill-base-contrast-80"
      />
      <path
        d="M1.83325 15.14C1.20325 12.355 2.59325 10.06 3.48825 8.935C4.96325 7.075 7.07825 5.82 8.75325 5.82C11.3283 5.82 13.2983 8.19 14.1833 9.475H16.1533C15.9683 9.13 14.3183 6.2 11.5783 4.84C12.7233 3.945 13.3283 2.58 13.5033 1.34C13.5533 1.005 13.4533 0.665 13.2283 0.405C12.9983 0.15 12.6733 0 12.3283 0H4.69825C4.32325 0 3.97325 0.18 3.74825 0.475C3.52825 0.775 3.45825 1.16 3.56325 1.52C3.76325 2.19 4.39325 3.865 5.79325 4.915C4.47825 5.565 3.19825 6.6 2.17325 7.895C0.298253 10.26 -0.396748 12.995 0.218252 15.59L0.258252 15.71C1.21825 18.095 4.14825 18.48 5.96325 18.48C6.67325 18.48 7.20825 18.42 7.38825 18.395L6.86825 16.765C5.81325 16.85 2.62325 16.94 1.83325 15.14ZM11.7283 1.67C11.4633 2.63 10.6983 4.145 8.55825 4.145C6.75825 4.145 5.82825 2.71 5.39325 1.67H11.7283Z"
        className="oui-fill-base-contrast-80"
      />
    </BaseIcon>
  );
};
